var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-security",
    width: 24,
    height: 25,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAACRklEQVRIia2WX2iPYRTHP/s12Si/UrRhWrSRUpuJXZM1F+KSJdTKvwtqqa1IrU0trdQuFqX865db7c6lUBKSFlnzL/+5oW1YiE6+j47X+7y/30++dXrfc55zvuc57/M853krKFymDMyX67tSQ3JlkHcATyQd/zNBHXARKACzJAXZ6v41QRXQDpwDxoGtsocKkG1cPu2K+QthDY4Aq+W0EFgGzHDO34Bh4LD0Y8B+oNL5fAUeAi+BL8AtoN8SLAceRCp5r08xBDxKjC0FDgDbgHmR+EabwRpnGAHeAGPADcn3SLAlPAh0Aa2SRqAW2CSftZZgpZTnwOYIWRZsAtclAc+AxUBTzu3tFyWQVUiK4bXG51qCvJRPRYK6gQlJdxHfKZ9gQko+I6AZGABmSwZki2GO7JM5V86ijICGEm0BgeuVJRiVUgPURwKu2GycPilbGurFZRi1BFedU1sk6C3Q6fRO2dLgOa7ldPTvybAvo+yxyHsSgcM4H4dedFrPJmB9JHA68u7RJo7fnKEXVQNPdSbuA6tIJzmk52DKWJVm3aDPZ61kKlTw2e3tFeo9aRiMkBtOuN3WE86Cb9dn1YsMu9VhS8VRYK98R8RFMoFhh9u2fcDJWJ8XZgKngF7pFrvTOyQTfATWuSR7gDvAxhTyDcBdVRvIbZE/eKfYpZ9XmVuczS6QM8APnYMWN3YJ2KUJ/oGsvwrrmtuB4+5kJmFtxhb0fIwk69K3mV4Aluh6vO3GbmpRbStGyX/Nsrz/ogWqzO7d4gB+Aoe2fc/+LKsCAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSecurity);
export default __webpack_public_path__ + "static/media/ico-security.aad288fa.svg";
export { ForwardRef as ReactComponent };